export default "__VITE_ASSET__qTr7vuUQ__"